<!-- eslint-disable max-len -->
<template>
  <div>
    <h4>RIWAYAT KARIR GURU</h4>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="$refs.modalCreate.show()">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data Riwayat Karir Guru</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.jenjang_pendidikan.$error}">
            <label> Jenjang Pendidikan </label>
            <j-input
              v-model="$v.data_master.jenjang_pendidikan.$model"
              placeholder="Jenjang Pendidikan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.jenis_lembaga.$error}">
            <label> Jenis Lembaga </label>
            <j-input
              v-model="$v.data_master.jenis_lembaga.$model"
              placeholder="Jenis Lembaga"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.status_kepegawaian.$error}">
            <label> Status Kepegawaian </label>
            <j-input
              v-model="$v.data_master.status_kepegawaian.$model"
              placeholder="Status Kepegawaian"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.jenis_ptk.$error}">
            <label> Jenis PTK </label>
            <j-input
              v-model="$v.data_master.jenis_ptk.$model"
              placeholder="Jenis PTK"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.no_sk_kerja.$error}">
            <label> Nomor SK Kerja </label>
            <j-input
              v-model="$v.data_master.no_sk_kerja.$model"
              placeholder="Fakultas"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tanggal_sk_kerja.$error}">
            <label> Tanggal SK Kerja </label>
            <j-datepicker
              v-model="$v.data_master.tanggal_sk_kerja.$model"
              placeholder="Tanggal SK Kerja"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tmt_kerja.$error}">
            <label> TMT Kerja </label>
            <j-datepicker
              v-model="$v.data_master.tmt_kerja.$model"
              placeholder="TMT Kerja"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tst_kerja.$error}">
            <label> TST Kerja </label>
            <j-datepicker
              v-model="$v.data_master.tst_kerja.$model"
              placeholder="TST Kerja"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tempat_kerja.$error}">
            <label> Tempat Kerja </label>
            <j-input
              v-model="$v.data_master.tempat_kerja.$model"
              placeholder="Tempat Kerja"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.ttd_sk_kerja.$error}">
            <label> TTD SK Kerja </label>
            <j-input
              v-model="$v.data_master.ttd_sk_kerja.$model"
              placeholder="TTD SK Kerja"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.mapel_yang_diajarkan.$error}">
            <label> Mapel Yang Dikerjakan </label>
            <j-input
              v-model="$v.data_master.mapel_yang_diajarkan.$model"
              placeholder="Semester"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data Riwayat Karir Guru</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.jenjang_pendidikan.$error}">
            <label> Jenjang Pendidikan </label>
            <j-input
              v-model="$v.data_master.jenjang_pendidikan.$model"
              :disabled="readOnly"
              placeholder="Jenjang Pendidikan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.jenis_lembaga.$error}">
            <label> Jenis Lembaga </label>
            <j-input
              v-model="$v.data_master.jenis_lembaga.$model"
              :disabled="readOnly"
              placeholder="Jenis Lembaga"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.status_kepegawaian.$error}">
            <label> Status Kepegawaian </label>
            <j-input
              v-model="$v.data_master.status_kepegawaian.$model"
              :disabled="readOnly"
              placeholder="Status Kepegawaian"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.jenis_ptk.$error}">
            <label> Jenis PTK </label>
            <j-input
              v-model="$v.data_master.jenis_ptk.$model"
              :disabled="readOnly"
              placeholder="Jenis PTK"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.no_sk_kerja.$error}">
            <label> Nomor SK Kerja </label>
            <j-input
              v-model="$v.data_master.no_sk_kerja.$model"
              :disabled="readOnly"
              placeholder="Fakultas"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tanggal_sk_kerja.$error}">
            <label> Tanggal SK Kerja </label>
            <j-datepicker
              v-model="$v.data_master.tanggal_sk_kerja.$model"
              :disabled="readOnly"
              placeholder="Tanggal SK Kerja"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tmt_kerja.$error}">
            <label> TMT Kerja </label>
            <j-datepicker
              v-model="$v.data_master.tmt_kerja.$model"
              :disabled="readOnly"
              placeholder="TMT Kerja"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tst_kerja.$error}">
            <label> TST Kerja </label>
            <j-datepicker
              v-model="$v.data_master.tst_kerja.$model"
              :disabled="readOnly"
              placeholder="TST Kerja"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tempat_kerja.$error}">
            <label> Tempat Kerja </label>
            <j-input
              v-model="$v.data_master.tempat_kerja.$model"
              :disabled="readOnly"
              placeholder="Tempat Kerja"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.ttd_sk_kerja.$error}">
            <label> TTD SK Kerja </label>
            <j-input
              v-model="$v.data_master.ttd_sk_kerja.$model"
              :disabled="readOnly"
              placeholder="TTD SK Kerja"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.mapel_yang_diajarkan.$error}">
            <label> Mapel Yang Dikerjakan </label>
            <j-input
              v-model="$v.data_master.mapel_yang_diajarkan.$model"
              :disabled="readOnly"
              placeholder="Semester"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="6">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  // eslint-disable-next-line
  name: 'jKarirGuru',
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      load_first: false,
      data_table: [],
      selected_rows: [],
      columns: ['jenjang_pendidikan', 'jenis_lembaga', 'status_kepegawaian', 'jenis_ptk', 'no_sk_kerja', 'tanggal_sk_kerja', 'tmt_kerja', 'tst_kerja', 'tempat_kerja', 'ttd_sk_kerja', 'mapel_yang_diajarkan'],
      options: {
        headings: {
          jenjang_pendidikan: 'JENJANG PENDIDIKAN',
          jenis_lembaga: 'JENIS LEMBAGA',
          status_kepegawaian: 'STATUS KEPEGAWAIAN',
          jenis_ptk: 'JENIS PTK',
          no_sk_kerja: 'NO SK KERJA',
          tanggal_sk_kerja: 'TANGGAL SK KERJA',
          tmt_kerja: 'TMT KERJA',
          tst_kerja: 'TST KERJA',
          tempat_kerja: 'TEMPAT KERJA',
          ttd_sk_kerja: 'TTD SK KERJA',
          mapel_yang_diajarkan: 'MAPEL YANG DIKERJAKAN',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['jenjang_pendidikan', 'jenis_lembaga', 'status_kepegawaian', 'jenis_ptk', 'no_sk_kerja', 'tanggal_sk_kerja', 'tmt_kerja', 'tst_kerja', 'tempat_kerja', 'ttd_sk_kerja', 'mapel_yang_diajarkan'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            id_pegawai: data.id_pegawai,
          };
        },
        requestFunction(data) {
          const getList = jApiKurikulum.getListKarirGuru(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      data_master: {
        id_pegawai: this.$route.params.id,
        jenjang_pendidikan: '',
        jenis_lembaga: '',
        status_kepegawaian: '',
        jenis_ptk: '',
        no_sk_kerja: '',
        tanggal_sk_kerja: null,
        tmt_kerja: null,
        tst_kerja: null,
        tempat_kerja: '',
        ttd_sk_kerja: '',
        mapel_yang_diajarkan: '',
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKurikulum', ['createKarirGuru', 'updateKarirGuru', 'deleteKarirGuru']),

    loading(val) {
      const a = val;
      a.id_pegawai = this.$route.params.id;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        jenjang_pendidikan: '',
        jenis_lembaga: '',
        status_kepegawaian: '',
        jenis_ptk: '',
        no_sk_kerja: '',
        tanggal_sk_kerja: null,
        tmt_kerja: null,
        tst_kerja: null,
        tempat_kerja: '',
        ttd_sk_kerja: '',
        mapel_yang_diajarkan: '',
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        jenjang_pendidikan: '',
        jenis_lembaga: '',
        status_kepegawaian: '',
        jenis_ptk: '',
        no_sk_kerja: '',
        tanggal_sk_kerja: null,
        tmt_kerja: null,
        tst_kerja: null,
        tempat_kerja: '',
        ttd_sk_kerja: '',
        mapel_yang_diajarkan: '',
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();
      this.data_master = {
        id: param.row.id,
        id_pegawai: param.row.id_pegawai,
        jenjang_pendidikan: param.row.jenjang_pendidikan,
        jenis_lembaga: param.row.jenis_lembaga,
        status_kepegawaian: param.row.status_kepegawaian,
        jenis_ptk: param.row.jenis_ptk,
        no_sk_kerja: param.row.no_sk_kerja,
        tanggal_sk_kerja: param.row.tanggal_sk_kerja,
        tmt_kerja: param.row.tmt_kerja,
        tst_kerja: param.row.tst_kerja,
        tempat_kerja: param.row.tempat_kerja,
        ttd_sk_kerja: param.row.ttd_sk_kerja,
        mapel_yang_diajarkan: param.row.mapel_yang_diajarkan,
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.createKarirGuru(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalCreate();
            }, 1500);
          }
        });
      }
    },

    updateData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.updateKarirGuru(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalUpdate();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteKarirGuru(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_master: {
        jenjang_pendidikan: { required },
        jenis_lembaga: { required },
        status_kepegawaian: { required },
        jenis_ptk: { required },
        no_sk_kerja: { required },
        tanggal_sk_kerja: { required },
        tmt_kerja: { required },
        tst_kerja: { required },
        tempat_kerja: { required },
        ttd_sk_kerja: { required },
        mapel_yang_diajarkan: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/tab-component/jKarirGuru.vue